// 900 is MUI's md breakpoint, the same one the footer Grid switches columns at. Tailwind's md is
// 960, so driving these off a `md:` class would leave a 60px window where the logo column already
// sits beside the menus but its text is still centred like mobile.
const DESKTOP_BREAKPOINT = 900;

export const useStylesFooterLayout = (width, theme) => {
	return {
		Phone: {
			pointerEvents: width > 600 ? 'none' : 'auto'
		},
		// Border longhand rather than the `border-top` shorthand: the shorthand resets
		// border-top-color to currentColor, which inside the footer AppBar resolves to MUI's
		// default contrast colour, not the channel's footer colour. Element opacity rather than
		// alpha() because footerTextColor is free text from a channel setting and alpha() throws
		// on CSS named colours such as `white`.
		divider: {
			borderTopWidth: '1px',
			borderTopStyle: 'solid',
			borderTopColor: theme.palette.footer.fontColor,
			opacity: 0.2,
			marginTop: '4rem',
			marginBottom: '2.4rem'
		},
		recaptchaText: {
			textAlign: 'center',
			fontSize: '1.2rem',
			lineHeight: 1.6,
			color: theme.palette.footer.fontColor
		}
	};
};

export const useStylesFooterLogo = (theme, secondaryLogoTextColor, width) => {
	// On desktop the logo column sits beside the menu columns, so its contents are left-aligned to
	// share their baseline. Stacked full-width on mobile it reads better centred.
	const isDesktop = width >= DESKTOP_BREAKPOINT;

	return {
		logo: {
			height: 'auto',
			width: 'auto',
			maxHeight: '100px',
			maxWidth: '120px',
			display: 'flex'
		},
		logoText: {
			fontSize: '1.2rem',
			lineHeight: 1.6,
			color: secondaryLogoTextColor ?? theme.palette.footer.fontColor,
			marginTop: '1.2rem',
			textAlign: isDesktop ? 'left' : 'center'
		},
		linkContainer: {
			display: 'flex',
			justifyContent: isDesktop ? 'flex-start' : 'center'
		},
		container: {
			display: 'flex',
			flexDirection: 'column',
			alignItems: isDesktop ? 'flex-start' : 'center',
			paddingRight: isDesktop ? '2.4rem' : 0
		}
	};
};
